export default {
    en: {
       tab: 'Awards',

        list: {
            awrdDvsCd: 'Classification',
            awrdNm: 'Title',
            cfmtAgcNm: 'Institution',
            awrdDt: 'Date'
        },

        detail: {
            cfmtNtnCd: 'Country',
            awrdNtnIo: 'Domestic/International',
            awrdDvsCd: 'Classification',
            awrdNm: 'Title',
            awrdTxt: 'Contents',
            cfmtAgcNm: 'Institution',
            awrdDt: 'Date',
            awrdAuthorNm: 'Co-winner',
            score: 'Points',
        },

        cdTable:{
            cd1:'Award (Research related)',
            cd2:'Award (Teaching related)',
            cd3:'Award (Service related)',
            cd2gubun1:'In-Campus (Outstanding Achievement Professor Award (Teaching))',
            cd2gubun2:'In-Campus (Best Educator Award)',
            cd2gubun3:'Off-Campus Awards (Education)',
            cd2gubun7:'ETC. (0)',
            cd3gubun4:'Outstanding National/International Service Award',
            cd3gubun5:'National/Outstanding Public Service Award',
            cd3gubun6:'Public/Private Service Award',
        },

        help:{
            line1:{
                1:'Awards entered in YRI and approved by YRI are transferred to the TAMS.',
                2:"- Inquiry about YRI: yri{'@'}yonsei.ac.kr (Phone +82-2-2123-6436)",
            }
        },
    },
    ko: {
        tab: '수상',

        list: {
            awrdDvsCd: '구분',
            awrdNm: '수상명',
            cfmtAgcNm: '수여기관',
            awrdDt: '수상일자'
        },
        
        detail: {
            cfmtNtnCd: '수여국',
            awrdNtnIo: '국내/국제',
            awrdDvsCd: '구분',
            awrdNm: '명칭',
            awrdTxt: '수여내용',
            cfmtAgcNm: '수여기관',
            awrdDt: '수상일자',
            awrdAuthorNm: '공동수상자명(본인포함)',
            score: '업적점수',
        },

        cdTable:{
            cd1:'연구관련수상',
            cd2:'교육관련수상',
            cd3:'봉사관련수상',
            cd2gubun1:'우수업적교수상(교육 - 대학본부수여)',
            cd2gubun2:'최우수교육자상 수상(교내)',
            cd2gubun3:'교육관련 교외수상',
            cd2gubun7:'기타 교육관련 수상(0점)',
            cd3gubun4:'저명 국제단체/국가(훈포장등) 봉사상',
            cd3gubun5:'국제단체 혹은 저명 공공단체 봉사상',
            cd3gubun6:'공공단체 혹은 민간단체 봉사상',
        },

        help:{
            line1:{
                1:'수상업적은 YRI에 입력/승인된 업적이 이 시스템(TAMS)에 반영됩니다.',
                2:"- YRI 관련 문의  yri{'@'}yonsei.ac.kr (내선 6436)",
            }
        },
    }
}